import React from 'react';
import Chip from "@mui/material/Chip";

export default function ChipTags({value: values}) {
    if (!values || values.length === 0) return null;

    return values.map((value, index) => (
        <Chip key={index} label={value}/>
    ))
}